import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Layouts
import DashboardLayout from '../../Layouts/DashboardLayout';

// Redux/actions
import { apiGetAllOrgRobotsRequest} from '../../Redux/actions/gear';

// Components
import RobotStatusDashboard from 'Components/RobotStatusDashboard';

// Constants
import { WebsocketClients, ROBOT_UNKNOWN_VALUE } from 'Config/websocketConstants';

const OrgRobotStatusDashboardPage = () => {
  const dispatch = useDispatch();

  // useSelector
  const auth = useSelector(state => state.auth);
  const userInformation = useSelector(state => state.userInformation);
  const gear = useSelector(state => state.gear);

  // useState
  const [robotAirIdsString, setRobotAirIdsString] = useState("");
  const [robotAirIds, setRobotAirIds] = useState([]);
  const [robotAirIdstoNickNames, setRobotAirIdstoNickNames] = useState({});

  useEffect(() => {
    if (userInformation?.selectedOrganisation) {
      dispatch(apiGetAllOrgRobotsRequest(auth.token, userInformation?.selectedOrganisation));
      return (() => {})
    }
  }, [userInformation?.selectedOrganisation]);

  useEffect(() => {
    if (gear.orgRobots && robotAirIds.length === 0) {
      let targetAirIds = [];
      let robotAidIdNameObj = {};
      gear.orgRobots.forEach(orgRobot => {
        targetAirIds.push(orgRobot.air_id);
        robotAidIdNameObj[orgRobot.air_id] = orgRobot?.robot_org_nick_name ?? ROBOT_UNKNOWN_VALUE;
      });
      setRobotAirIdsString(targetAirIds.join(","));
      setRobotAirIds(targetAirIds);
      setRobotAirIdstoNickNames(robotAidIdNameObj);
    }
  }, [gear.orgRobots]);

  return (
    <DashboardLayout>
      <RobotStatusDashboard
        dashboardHeader={'Organization Robot Status Dashboard'}
        dashboardSubHeader={'View Organization Robot Real-time Status In One Dashboard'}
        robotAirIdsString={robotAirIdsString}
        robotAirIds={robotAirIds}
        robotAirIdstoNickNames={robotAirIdstoNickNames}
        wsClientName={WebsocketClients.ORG_ROBOT_STATUS}
      />
    </DashboardLayout>
  );
};

export default OrgRobotStatusDashboardPage;
